import { render } from "./CounterView.vue?vue&type=template&id=3cce0b96&scoped=true"
import script from "./CounterView.vue?vue&type=script&lang=js"
export * from "./CounterView.vue?vue&type=script&lang=js"

import "./CounterView.vue?vue&type=style&index=0&id=3cce0b96&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cce0b96"]])

export default __exports__